const StorageTypes = {
  TOKEN: "TOKEN",
  USER: "USER",
  BANNER_MODEL: "BANNER_MODEL",
  IMAGE_BG: "IMAGE_BG",
  FONT_OPTIONS: "FONT_OPTIONS",
};

export default StorageTypes;
